import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-title-section',
    templateUrl: './title-section.component.html',
    styleUrls: ['./title-section.component.scss'],
    standalone: false
})
export class TitleSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
